import { Action } from 'redux';

import { SetCustomLabel } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';

export interface SetCustomLabelAction extends Action {
    item: IContentInfo;
}

export function setCustomLabelAction(item: SetCustomLabelAction['item']): SetCustomLabelAction {
    return {
        type: SetCustomLabel,
        item
    };
}
